
<style>
    .form-material select, .form-material input, .form-material textarea, languageSelector select {
      width: 100%;
      font-size:14px;
    }

  .form-material select {
    font-size:14px;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  .languageContainer {
    display:block;
    margin-bottom:10px;
  }

  .globalContainer {
    display:block;
    margin-bottom:10px;
    padding:12px;
  }

  textarea {min-height: 100px;}

  </style>

  <app-modal-header [headerTitle]="'Edit Lectionary Track'"  ></app-modal-header>


  <div class="globalContainer" *ngIf="item != null && listsLoaded == true">

      <div  style="border-bottom:1px solid gray">All Languages</div>

      <div class="form-group row">

        <div class="col-6">

            <div class="form-material">

                <select [ngModel]="item.ReligionBranch?.Id"  (ngModelChange)="item.ReligionBranch = setModelValue($event, item.ReligionBranch)">
                    <option *ngFor="let section of religionBranches" [ngValue]="section.Id">
                        {{section.Name}}
                    </option>
                  </select>

                <label for="">Religion Branch</label>

            </div>

        </div>


      <div class="col-6">
          <div class="form-material">
              <input matInput [(ngModel)]="item.NameAbbreviated">
              <label for="">Name Abbreviated</label>
          </div>
      </div>

      <div class="col-12">
        <div class="form-material">
          <input matInput [(ngModel)]="item.Name">
          <label for="">Full Name</label>
        </div>
      </div>

        <div class="col-12">
          <div class="form-material">
              <textarea matInput [(ngModel)]="item.Description"></textarea>
              <label for="">Description</label>
          </div>
      </div>

      <div class="col-6">
        <div class="form-material">
          <input matInput [(ngModel)]="item.CopyrightYear">
            <label for="">Copyright Year</label>
        </div>
    </div>

    <div class="col-6">
        <div class="form-material">
          <input matInput [(ngModel)]="item.CopyrightText">
            <label for="">Copyright Text</label>
        </div>
    </div>

    <div class="col-6">
      <div class="form-material">
        <input matInput [(ngModel)]="item.CopyrightNote">
          <label for="">Copyright Note</label>
      </div>
  </div>

      </div>

  </div>


  <div mat-dialog-actions class="float-right">
  <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
  <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>

  </div>


